import { isEmpty } from "lodash";
import { useEffect, useState } from "react";

const useOptions = ( props:{ language:string } ) => {
    const [ fetched, setFetched ] = useState<boolean>(false);

    useEffect(
        () => {
            if ( !isEmpty(props.language) ) {
                fetch(`${window.location.origin}/_options/${props.language}`)
                    .then(async (response:Response) => {
                        return await response.json();
                    })
                    .then((data:any) => {
                        const armadorPayload = document?.getElementById('ARMADORPayload');
                        if ( armadorPayload ) armadorPayload.remove();

                        const script = `<script id="ARMADORPayload">${JSON.stringify(data)}</script>`;
                        
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(script, "text/html");
                        document.head.insertAdjacentHTML('beforeend', doc.head.innerHTML);
                        
                        setFetched(true);
                    })
            }
        }, [props.language]
    )

    return fetched;
}

export default useOptions;